import { i18n } from '@/locales';
import { workerMonthAttendanceDayList } from '@/constants/workerMonthlyAttendance/workerMonthlyAttendanceDayList';
const { t } = i18n;
const lc = 'views.worker.worker_monthly_attendance.table_header.';
// 하루의 출퇴근 데이터 템플릿
const workerMonthAttendanceDailyTableHeaderTemplate = {
    title: '',
    key: 'daily',
    sortable: false,
    align: 'center',
    width: 130 * 6,
    headerProps: {
        class: 'th-index-0',
    },
    children: [
        {
            title: t(`${lc}start_worked_at`),
            value: 'formattedStartWorkedAt',
            align: 'center',
            headerProps: {
                class: 'th-index-0',
            },
        },
        {
            title: t(`${lc}end_worked_at`),
            value: 'formattedEndWorkedAt',
            align: 'center',
        },
        {
            title: t(`${lc}total_delivery_count`),
            value: 'formattedTotalDeliveryCount',
            align: 'center',
        },
        {
            title: t(`${lc}working_time`),
            value: 'workingTime',
            key: 'workingTime',
            sortable: false,
            align: 'center',
        },
        {
            title: t(`${lc}total_delivery_count_in_period`),
            value: 'formattedTotalDeliveryCountInPeriod',
            align: 'center',
        },
        {
            title: t(`${lc}working_time_in_period`),
            value: 'workingTimeInPeriod',
            key: 'workingTimeInPeriod',
            sortable: false,
            align: 'center',
        },
    ],
};
// Template을 31일치 복사한 값(title 재정의)
const workerMonthAttendanceDailyTableHeader = workerMonthAttendanceDayList.map((_, index) => {
    const date = index + 1;
    // 1일 2일 header
    const title = t(`${lc}day`, {
        date,
    });
    return {
        ...workerMonthAttendanceDailyTableHeaderTemplate,
        title,
        day: index,
    };
});
export const workerMonthlyAttendanceTableHeader = [
    {
        title: t(`${lc}worker_name`),
        value: 'formattedWorkerName',
        width: 130,
        align: 'center',
        fixed: true,
    },
    {
        title: t(`${lc}hub_name`),
        value: 'formattedHubName',
        align: 'center',
        width: 120,
    },
    {
        title: t(`${lc}employee_type`),
        value: 'formattedEmployeeType',
        align: 'center',
        width: 160,
    },
    {
        title: t(`${lc}salary_type`),
        value: 'formattedSalaryType',
        align: 'center',
        width: 160,
    },
    {
        title: t(`${lc}hub_employee_number`),
        value: 'formattedHubEmployeeNumber',
        align: 'center',
        width: 110,
    },
    ...workerMonthAttendanceDailyTableHeader,
    // 합계
    {
        title: t(`${lc}sum`),
        align: 'center',
        key: 'sum',
        sortable: false,
        width: 1650,
        headerProps: {
            class: 'th-total',
        },
        children: [
            {
                title: t(`${lc}sum_working_time`),
                key: 'sumWorkingTime',
                sortable: false,
                align: 'center',
                headerProps: {
                    class: 'th-total-first',
                },
            },
            {
                title: t(`${lc}sum_working_count`),
                value: 'formattedSumWorkingCount',
                align: 'center',
                headerProps: {
                    class: 'th-total',
                },
            },
            {
                title: t(`${lc}sum_delivery_count`),
                value: 'formattedSumDeliveryCount',
                align: 'center',
                headerProps: {
                    class: 'th-total',
                },
            },
            {
                title: t(`${lc}avg_working_minute`),
                value: 'formattedAvgWorkingMinute',
                align: 'center',
                headerProps: {
                    class: 'th-total',
                },
            },
            {
                title: t(`${lc}avg_delivery_count`),
                value: 'formattedAvgDeliveryCount',
                align: 'center',
                headerProps: {
                    class: 'th-total',
                },
            },
            {
                title: t(`${lc}avg_delivery_count_by_hour`),
                value: 'formattedAvgDeliveryCountByHour',
                align: 'center',
                headerProps: {
                    class: 'th-total',
                },
            },
            {
                title: t(`${lc}sum_working_minute_in_period`),
                value: 'formattedSumWorkingMinuteInPeriod',
                align: 'center',
                headerProps: {
                    class: 'th-total',
                },
            },
            {
                title: t(`${lc}sum_delivery_count_in_period`),
                value: 'formattedSumDeliveryCountInPeriod',
                align: 'center',
                headerProps: {
                    class: 'th-total',
                },
            },
            {
                title: t(`${lc}avg_working_minute_in_period`),
                value: 'formattedAvgWorkingMinuteInPeriod',
                align: 'center',
                headerProps: {
                    class: 'th-total',
                },
            },
            {
                title: t(`${lc}avg_delivery_count_in_period`),
                value: 'formattedAvgDeliveryCountInPeriod',
                align: 'center',
                headerProps: {
                    class: 'th-total',
                },
            },
            {
                title: t(`${lc}avg_delivery_count_in_period_hour`),
                value: 'formattedAvgDeliveryCountInPeriodHour',
                align: 'center',
                headerProps: {
                    class: 'th-total',
                },
            },
        ],
    },
];
